<template>
<div class="wlx-ph-login">
    <div class="login-hade-tab clearfix">
        <div class="user-account-login">
            <span>账号登录</span>
        </div>
    </div>
    <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
            <div class="from-account-login">
                <!-- <el-form-item style="margin-top:22px">
                        <el-select filterable clearable v-model="ruleForm.schoolId" placeholder="请选择学校" class="form_input">
                            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <div class="left-icon">
                            <i class="wl-icon-xuexiao"></i>
                        </div>
                    </el-form-item> -->
                <el-form-item prop="userName" style="margin-top:22px">
                    <el-input placeholder="请输入账号" prefix-icon="wl-icon-yonghu" v-model="ruleForm.userName"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input placeholder="请输入密码" prefix-icon="wl-icon-mima1" v-model="ruleForm.password" type="password" @keyup.enter.native="login()"></el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <el-button type="primary" @click="login">登&nbsp;录</el-button>
            </el-form-item>
            <p class="p-enter-register clearfix">
                <span class="sp-left" @click="goHome">返回首页</span>

                <span class="sp-right" @click="enterRegister">点击注册</span>
                <span class="sp-right sp-forget-password" @click="forgetPassword">忘记密码</span>
            </p>
        </el-form>
    </div>
</div>
</template>

<script>
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
export default {
    data() {
        return {
            ruleForm: {
                userName: "",
                password: "",
                phone: "",
                captcha: "",
                schoolId: "",
            },
            schoolList: [],
            rules: {
                userName: [{
                    required: true,
                    message: "请输入用户账号",
                    trigger: "change"
                }],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "change"
                }],
                phone: [{
                    required: true,
                    message: "请输入手机号",
                    trigger: "change"
                }],
                captcha: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "change"
                }],
            },
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        },
    },
    created() {
        if (localStorage["userId"] !== undefined) {
            this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
        }
        this.$store.dispatch(MU_UPATE_SCHOOL, {
            id: window.location.href
        });
        this.getSchoolList();
    },
    methods: {
        forgetPassword() {
           this.$router.push({
               name:'retrievePassword'
           });
        },
        getSchoolList() {
            var that = this;
            this.$http
                .post("/api/common/login/getSchoolList", {
                    schoolType: "zwl",
                })
                .then((rst) => {
                    if (rst && rst.code > 0) {
                        that.schoolList = rst.list;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        enterRegister() {
            this.$router.push({
                name: "phRegister",
            });
        },
        login: function () {
            var that = this;
            this.loadingTip(true);
            this.$http
                .post("/api/XOrg/XLogin/Accountlogin", {
                    userName: that.ruleForm.userName,
                    userPwd: that.ruleForm.password,
                    schoolId: that.ruleForm.schoolId,
                })
                .then((rst) => {
                    if (rst && rst.code > 0) {
                        if (rst.code === 1) {
                            localStorage["userName"] = this.ruleForm.userName;
                            localStorage["userId"] = rst.userId;
                        }
                        this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {
                            this.loadingTip(false);
                            // 登录完获取回登录信息跳转
                            this.$router.push({
                                name: "xIndex",
                            });
                        });
                    } else {
                        this.loadingTip(false);
                        this.$message.warning(rst.msg);
                    }
                });
        },
        loadingTip(is) {
            if (is) {
                this.$loading({
                    lock: true,
                    text: "正在登录...",
                });
            } else {
                this.$loading({}).close();
            }
        },
        target_() {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "xIndex";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 5) {
                Urlname = "managerIndex";
            }
            return Urlname;
        },
    },
};
</script>

<style lang="scss">
.wlx-ph-login {
    height: 100%;
    background: #fff;

    .left-icon {
        position: relative;

        .wl-icon-xuexiao1 {
            position: absolute;
            top: -42px;
            left: 15px;
            font-size: 20px;
            color: #666666;
        }
    }

    .el-select {
        width: 100%;

        .el-input__inner {
            width: 100%;
            padding-left: 45px;
        }
    }

    .el-input__prefix {
        margin-left: 9px;
        font-size: 20px;
        color: #666666;
    }

    .el-input__inner {
        padding-left: 46px;
    }

    .login-role-tab {
        position: absolute;
        right: -94px;
        top: 0;

        .login-role-tab-li {
            width: 94px;
            height: 40px;
            background: rgba(51, 51, 51, 0.5);
            color: #fff;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .active_role {
            background: #333333;
        }
    }

    .login-hade-tab {
        font-size: 18px;
        color: #2d82ff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;

        .user-account-login {
            float: left;
            width: 100%;
            border-bottom: 2px solid #2d82ff;
        }
    }

    .login-form-input {
        padding: 0 20px;
        margin-top: 35px;

        .go-register-right {
            float: right;
            color: #297efd;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;

            i {
                font-size: 22px;
                vertical-align: -3px;
            }
        }

        .captcha-phone-input {
            float: left;
            width: 266px;
        }

        .captcha-phone-button {
            float: right;
            width: 138px;
            font-size: 14px;
        }
    }

    .el-button--primary {
        color: #fff;
        background-color: #2d82ff;
        border-color: #2d82ff;
        width: 100%;
    }

    .p-enter-register {
        color: #2d82ff;

        .sp-left {
            float: left;
        }

        .sp-right {
            float: right;
        }

        .sp-forget-password {
            margin-right: 20px;
        }
    }

    .el-input {
        font-size: 16px;
        color: #666666;
    }

    .from-account-login {
        position: relative;

        .wl-icon-xuexiao {
            font-size: 18px;
            position: absolute;
            top: -41px;
            left: 17px;
        }
    }
}
</style>
